import { useState, useEffect } from "react";
import { fetchTopics } from "../services/fetchTopics";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchTopics() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("useFetchTopics called");

    const loadTopics = async () => {
      try {
        // console.log("breadcrumbs", breadcrumbs);
        const subject =
          breadcrumbs.find((item) => item.path === "/levels")?.id ||
          null;
        const level =
          breadcrumbs.find((item) => item.path === "/topics")?.id ||
          null;
          // console.log("subject", subject);
          // console.log("level", level);
        const data = await fetchTopics(auth.token, subject, level);
        // setTopics(data);
        if (data.status === 200) {
          const fnldata = data.data.map((topic) => ({
            id: topic.id,
            name: topic.title,
            image: `${process.env.REACT_APP_PUBLIC_API_URL}${topic.thumbnail}`,
          }));
          setTopics(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    loadTopics();
  }, [auth, breadcrumbs, setCommonWarning]);

  return [topics, loading];
}

export default useFetchTopics;
